import styled from 'styled-components';
import { Theme, getBodyStyle } from 'styles/theme';
import { breakpoint } from 'styles/globals';

export const Wrapper = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  & > div > span:first-child {
    display: block;
    font-weight: 600;
    padding-bottom: 1.5rem;
  }

  div:nth-child(2) > span:last-child {
    font-size: 0.75rem;
    text-transform: uppercase;
  }

  p:not( :first-child ) {
    margin-top: 24px;
  }
  
  @media(${breakpoint.mdMin}) {
    padding-top: 0;
  }

  @media(${breakpoint.lgMin}) {
    padding: 0px 24px;
    display: grid;
    grid-template-columns: minmax(0, 55%) 1fr;
    column-gap: 80px;
  }
`;

export default Wrapper;
